export enum ShipmentOperation {
    CREATE = 'operation.entity.shipment-request.create'
}
